exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body.overflow-auto[data-v-9cc8b2b8]{overflow:auto}.pagination[data-v-9cc8b2b8]{display:inline-block!important}", ""]);

// exports
